module.exports = __webpack_public_path__ + "static/media/right.af90ee14.svg";